import script from "./PdfDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__